import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class Tariffs extends CommonCRUD {}

export default Tariffs;
